import { Component, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "oz-dfu-replug",
  templateUrl: "./replug-device.component.pug",
})
export class DfuReplugComponent {
  @Output("continue") _continue = new EventEmitter();
}
